<template>
  <div id="contenedor-infraestructura-configuracion-caracteristicas-subtipos-infraestructura-desktop">
    <v-data-table
      :headers="headers"
      :items="listadoCaracteristciasSubtipoInfraestructura">
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :caracteristicaSubtipoInfraestructura="item"></opciones>
      </template>
      <!-- <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="new Date(item.createdAt)"></fecha-humano>
      </template> -->
    </v-data-table>
  </div>
</template>

<script>
import Opciones from './Opciones.vue';

export default {
  name: 'InfraestructuraConfiguracionCaracteristicasSubtiposInfraestructuraDesktop',
  props: {
    listadoCaracteristciasSubtipoInfraestructura: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
  },
  data() {
    return {
      headers: [
        { text: 'Caracteristica Subtipo', sortable: false, value: 'descripcion' },
        {
          text: '', align: 'end', sortable: false, value: 'acciones',
        },
      ],
    };
  },
};
</script>

<style lang="scss">

</style>
